import cn from 'classnames'
import React from 'react'

import styles from './Option.module.scss'

import Checkbox from '~shared/ui/Checkbox'

interface OptionProps<T extends unknown> extends React.HTMLAttributes<HTMLButtonElement> {
  icon?: React.ReactNode
  children?: React.ReactNode
  selected?: boolean
  disabled?: boolean
  value?: T
  onSelectOption?: (v: T, ev: React.MouseEvent<HTMLButtonElement>) => void
}

function Option<T extends unknown>({
  icon,
  children,
  selected,
  disabled,
  className,
  value,
  onSelectOption,
  onClick,
  onKeyDown,
  ...props
}: OptionProps<T>) {
  const handleOnClick = (ev: React.MouseEvent<HTMLButtonElement>) => {
    onClick?.(ev)

    if (!disabled) {
      onSelectOption?.(value, ev)
    }
  }

  return (
    <button
      role="option"
      aria-selected={selected}
      aria-disabled={disabled}
      className={cn(styles.root, disabled && styles.disabled, selected && styles.selected, className)}
      onClick={handleOnClick}
      {...props}
    >
      <Checkbox checked={selected} className={styles.checkbox} />
      {icon && <span className={styles.icon}>{icon}</span>}
      <span className={styles.content}>{children}</span>
    </button>
  )
}

export default Option
